import { BrandDiscoverOrdering } from "~src/api/discover";

export const generateTableHeader = (columns: string[]) => {
  let tableHeaders = DEFAULT_TABLE_HEAD;

  const sortedColumns = columnDisplayOrder.filter((col) =>
    columns.includes(col),
  );

  sortedColumns.forEach((column) => {
    switch (column) {
      case "fblikes":
        tableHeaders = [
          ...tableHeaders,
          {
            id: BrandDiscoverOrdering.LatestFbLikesAsc,
            label: "FB Likes",
            align: "left",
          },
        ];
        break;
      case "instagram_followers":
        tableHeaders = [
          ...tableHeaders,
          {
            id: BrandDiscoverOrdering.LatestInstagramFollowersAsc,
            label: "IG Followers",
            align: "left",
          },
        ];
        break;
      case "fbads_count":
        tableHeaders = [
          ...tableHeaders,
          {
            id: BrandDiscoverOrdering.FacebookAdCountAsc,
            label: "FB Ads",
            align: "left",
          },
        ];
        break;
      case "latest_shopifyreviews_count":
        tableHeaders = [
          ...tableHeaders,
          {
            id: BrandDiscoverOrdering.ShopifyReviewsCountAsc,
            label: "Shopify Reviews",
            align: "left",
          },
        ];
        break;
      case "latest_numberreviews":
        tableHeaders = [
          ...tableHeaders,
          {
            id: BrandDiscoverOrdering.TrustPilotReviewsCountAsc,
            label: "Trustpilot Reviews",
            align: "left",
          },
        ];
        break;
      case "latest_fbreviews":
        tableHeaders = [
          ...tableHeaders,
          {
            id: BrandDiscoverOrdering.LatestFbReviewsAsc,
            label: "Facebook Reviews",
            align: "left",
          },
        ];
        break;
      case "latest_redditgrowth":
        tableHeaders = [
          ...tableHeaders,
          {
            id: BrandDiscoverOrdering.LatestRedditGrowthAsc,
            label: "Reddit Growth",
            align: "left",
          },
        ];
        break;
      case "latest_redditmentions":
        tableHeaders = [
          ...tableHeaders,
          {
            id: BrandDiscoverOrdering.LatestRedditMentionsAsc,
            label: "Reddit Mentions",
            align: "left",
          },
        ];
        break;
      case "estimated_monthly_traffic":
        tableHeaders = [
          ...tableHeaders,
          {
            id: BrandDiscoverOrdering.EstimatedMonthlyTrafficAsc,
            label: "Est. Mon. Traffic",
            align: "left",
          },
        ];
        break;
      case "estimated_monthly_orders":
        tableHeaders = [
          ...tableHeaders,
          {
            id: BrandDiscoverOrdering.EstimatedMonthlyOrdersAsc,
            label: "Est. Mon. Orders",
            align: "left",
          },
        ];
        break;
      case "estimated_monthly_revenue":
        tableHeaders = [
          ...tableHeaders,
          {
            id: BrandDiscoverOrdering.EstimatedMonthlyRevenueAsc,
            label: "Est. Mon. Revenue",
            align: "left",
          },
        ];
        break;
      case "count":
        tableHeaders = [
          ...tableHeaders,
          {
            id: BrandDiscoverOrdering.ProductDataCountAsc,
            label: "Product Count",
            align: "left",
          },
        ];
        break;
      case "min_price":
        tableHeaders = [
          ...tableHeaders,
          {
            id: BrandDiscoverOrdering.ProductDataMinPriceAsc,
            label: "Min Price",
            align: "left",
          },
        ];
        break;
      case "avg_price":
        tableHeaders = [
          ...tableHeaders,
          {
            id: BrandDiscoverOrdering.ProductDataAvgPriceAsc,
            label: "Avg Price",
            align: "left",
          },
        ];
        break;
      case "max_price":
        tableHeaders = [
          ...tableHeaders,
          {
            id: BrandDiscoverOrdering.ProductDataMaxPriceAsc,
            label: "Max Price",
            align: "left",
          },
        ];
        break;
      case "last_30_days":
        tableHeaders = [
          ...tableHeaders,
          {
            id: BrandDiscoverOrdering.NewProductsLast30DaysAsc,
            label: "New Products - 30 days",
            align: "left",
          },
        ];
        break;
      default:
        break;
    }
  });

  return tableHeaders;
};

const DEFAULT_TABLE_HEAD = [
  { id: BrandDiscoverOrdering.BrandNameAsc, label: "Brand", align: "left" },
  {
    id: BrandDiscoverOrdering.ScalingScoreRankingAsc,
    label: "Scale",
    align: "left",
  },
  {
    id: BrandDiscoverOrdering.RevenueScoreRankingAsc,
    label: "Revenue",
    align: "left",
  },
  { id: "description", label: "Description", align: "left" },
];

const columnDisplayOrder = [
  "fblikes",
  "instagram_followers",
  "fbads_count",
  "latest_shopifyreviews_count",
  "latest_numberreviews",
  "latest_fbreviews",
  "latest_redditgrowth",
  "latest_reditmentions",
  "estimated_monthly_traffic",
  "estimated_monthly_orders",
  "estimated_monthly_revenue",
  "count",
  "min_price",
  "avg_price",
  "max_price",
  "last_30_days",
];
